import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://daclair.com';
const DEFAULT_IMAGE = `${BASE_URL}/assets/og/og_default.jpg`;
const SITE_NAME = '다끌레어 (Daclair)';

// 페이지별 SEO 메타 정보
const PAGE_META = {
  '/': {
    title: '다끌레어 (Daclair) — 스마트 환경 솔루션 플랫폼',
    description: '텀블러 세척기, 청소 카트, 탄소중립 리포트까지. 다끌레어는 ESG 실천을 돕는 스마트 환경 솔루션 플랫폼입니다.',
    image: `${BASE_URL}/assets/og/og_default.jpg`,
  },
  '/products/tumblerwasher': {
    title: '텀블러 세척기 — 다끌레어',
    description: 'QR 스캔으로 시작하는 스마트 텀블러 세척기. 98% 물 절약, 60% 전기 절약, 세척당 500g CO₂ 절감. 3가지 형태(독립형·테이블형·멀티형)로 도입 가능합니다.',
    image: `${BASE_URL}/assets/og/og_tumbler_washer.jpg`,
  },
  '/products/cleaningcart': {
    title: '청소 카트 — 다끌레어',
    description: '다끌레어의 스마트 청소 카트. ESG 데이터 수집과 청소 업무 효율화를 동시에 실현합니다.',
    image: `${BASE_URL}/assets/og/og_cleaning_cart.jpg`,
  },
  '/services/daclair': {
    title: '다끌레어 서비스 — 다끌레어',
    description: '다끌레어 앱으로 텀블러 사용 포인트를 적립하고, 제로웨이스트 라이프스타일을 시작하세요.',
    image: `${BASE_URL}/assets/og/og_service_daclair.jpg`,
  },
  '/services/env-report': {
    title: 'ENV-REPORT — 다끌레어',
    description: '텀블러 세척기 사용 데이터를 기반으로 절약된 물·전기·탄소량을 자동 계산하여 기업 환경 통계 리포트를 제공합니다.',
    image: `${BASE_URL}/assets/og/og_service_env_report.jpg`,
  },
  '/services/env-ad': {
    title: 'ENV-AD — 다끌레어',
    description: '다끌레어 유저 앱·텀블러 세척기 화면·청소 카트 디스플레이에 친환경 광고를 게재하세요.',
    image: `${BASE_URL}/assets/og/og_service_env_ad.jpg`,
  },
  '/services/vcm': {
    title: '탄소중립마켓 (VCM) — 다끌레어',
    description: '탄소 감축 활동을 탄소 크레딧으로 전환하고 거래하는 자발적 탄소 시장(VCM) 플랫폼입니다.',
    image: `${BASE_URL}/assets/og/og_service_vcm.jpg`,
  },
  '/company/mission': {
    title: '회사 소개 — 다끌레어',
    description: '다끌레어는 환경 기술로 더 깨끗한 세상을 만들어갑니다. 회사의 미션과 비전을 확인하세요.',
    image: `${BASE_URL}/assets/og/og_company.jpg`,
  },
  '/company/sustainability': {
    title: '지속가능성 — 다끌레어',
    description: '다끌레어의 ESG 경영과 탄소중립 실천 현황을 확인하세요.',
    image: `${BASE_URL}/assets/og/og_company.jpg`,
  },
  '/company/contact': {
    title: '문의하기 — 다끌레어',
    description: '도입 문의, 구입 상담, 파트너십 등 다끌레어에 문의하세요. 영업일 기준 1~2일 내에 답변드립니다.',
    image: `${BASE_URL}/assets/og/og_default.jpg`,
  },
  '/campaigns': {
    title: '캠페인 — 다끌레어',
    description: '다끌레어의 최신 환경 캠페인과 이벤트를 확인하세요.',
    image: `${BASE_URL}/assets/og/og_default.jpg`,
  },
  '/manuals': {
    title: '사용설명서 — 다끌레어',
    description: '텀블러 세척기, 청소 카트 등 다끌레어 제품의 사용 가이드를 확인하세요.',
    image: `${BASE_URL}/assets/og/og_default.jpg`,
  },
};

export default function SeoHead({ pathname }) {
  // 경로 매칭: 정확 일치 우선, 없으면 prefix 탐색
  const meta =
    PAGE_META[pathname] ||
    Object.entries(PAGE_META).find(([key]) =>
      key !== '/' && pathname.startsWith(key)
    )?.[1] ||
    PAGE_META['/'];

  const canonicalUrl = `${BASE_URL}${pathname === '/' ? '' : pathname}`;

  return (
    <Helmet>
      {/* 기본 메타 */}
      <html lang="ko" />
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph (Facebook, KakaoTalk, 슬랙 등) */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.description} />
      <meta property="og:image" content={meta.image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:locale" content="ko_KR" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={meta.title} />
      <meta name="twitter:description" content={meta.description} />
      <meta name="twitter:image" content={meta.image} />

      {/* 구글 검색 추가 메타 */}
      <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
    </Helmet>
  );
}
